// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oir-pagination {
  margin: 0 0 20px;
  text-align: right;
}
.oir-pagination.hidden {
  display: none;
}
.oir-pagination .page {
  display: inline-block;
  margin-right: 20px;
  padding-top: 25px;
  font-size: 15px;
  font-family: Montserrat-Light, sans-serif;
}
.oir-pagination ul {
  display: inline-block;
  margin: 0;
  padding: 0;
}
.oir-pagination .control {
  display: inline-block;
  font-family: Montserrat-Light, sans-serif;
  border-radius: 50px;
  border: none;
  text-align: center;
  margin: 0 5px;
  outline: none;
  box-shadow: none;
}
.oir-pagination .control.current {
  background-color: #7F6C2E;
  color: white;
  text-align: center;
  font-weight: 600;
}
.oir-pagination .control a,
.oir-pagination .control span {
  text-decoration: none;
  display: inline-block;
  height: 25px;
  min-width: 25px;
  padding: 3px;
}
.oir-pagination .control.first,
.oir-pagination .control.previous {
  margin-right: 8px;
}
.oir-pagination .control.next,
.oir-pagination .control.last {
  margin-left: 8px;
}
.oir-pagination .control.first,
.oir-pagination .control.previous,
.oir-pagination .control.next,
.oir-pagination .control.last {
  margin: 0;
  padding: 0;
  min-width: auto;
}
.oir-pagination .control.first a,
.oir-pagination .control.previous a,
.oir-pagination .control.next a,
.oir-pagination .control.last a {
  font-weight: 100;
  color: #7F6C2E;
  transform: scale(1, 2.2);
  -webkit-transform: scale(1, 2.2);
  display: inline-block;
  font-size: 13px;
  line-height: 10px;
  vertical-align: sub;
  height: 23px;
}
.oir-pagination .control.first.disabled,
.oir-pagination .control.previous.disabled,
.oir-pagination .control.next.disabled,
.oir-pagination .control.last.disabled {
  cursor: no-drop;
}
.oir-pagination .control.first.disabled a,
.oir-pagination .control.previous.disabled a,
.oir-pagination .control.next.disabled a,
.oir-pagination .control.last.disabled a {
  color: #bfbbaa !important;
  pointer-events: none;
}
.oir-pagination .control:hover:not(.disabled),
.oir-pagination .control:active:not(.disabled),
.oir-pagination .control:focus:not(.disabled) {
  background-color: #7F6C2E;
  text-align: center;
}
.oir-pagination .control:hover:not(.disabled) a,
.oir-pagination .control:active:not(.disabled) a,
.oir-pagination .control:focus:not(.disabled) a {
  color: white !important;
}
.oir-pagination .control.first:hover:not(.disabled),
.oir-pagination .control.previous:hover:not(.disabled),
.oir-pagination .control.next:hover:not(.disabled),
.oir-pagination .control.last:hover:not(.disabled),
.oir-pagination .control.first:active:not(.disabled),
.oir-pagination .control.previous:active:not(.disabled),
.oir-pagination .control.next:active:not(.disabled),
.oir-pagination .control.last:active:not(.disabled),
.oir-pagination .control.first:focus:not(.disabled),
.oir-pagination .control.previous:focus:not(.disabled),
.oir-pagination .control.next:focus:not(.disabled),
.oir-pagination .control.last:focus:not(.disabled) {
  text-align: center;
  font-weight: 800;
  background-color: transparent !important;
}
.oir-pagination .control.first:hover:not(.disabled) a,
.oir-pagination .control.previous:hover:not(.disabled) a,
.oir-pagination .control.next:hover:not(.disabled) a,
.oir-pagination .control.last:hover:not(.disabled) a,
.oir-pagination .control.first:active:not(.disabled) a,
.oir-pagination .control.previous:active:not(.disabled) a,
.oir-pagination .control.next:active:not(.disabled) a,
.oir-pagination .control.last:active:not(.disabled) a,
.oir-pagination .control.first:focus:not(.disabled) a,
.oir-pagination .control.previous:focus:not(.disabled) a,
.oir-pagination .control.next:focus:not(.disabled) a,
.oir-pagination .control.last:focus:not(.disabled) a {
  color: #7F6C2E !important;
  background-color: #f4f2ea !important;
}
.oir-pagination.hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/pagination/pagination.component.less"],"names":[],"mappings":"AAEA;EACI,gBAAA;EACA,iBAAA;AADJ;AAGI;EACI,aAAA;AADR;AAJA;EASQ,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yCAAA;AAFR;AAXA;EAiBQ,qBAAA;EACA,SAAA;EACA,UAAA;AAHR;AAhBA;EAuBQ,qBAAA;EACA,yCAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;AAJR;AAMQ;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAJZ;AAhCA;;EAyCY,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AALZ;AAQQ;;EAEI,iBAAA;AANZ;AASQ;;EAEI,gBAAA;AAPZ;AAUQ;;;;EAII,SAAA;EACA,UAAA;EACA,eAAA;AARZ;AAEQ;;;;EASQ,gBAAA;EACA,cAAA;EACA,wBAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AALhB;AAQY;;;;EACI,eAAA;AAHhB;AAEY;;;;EAIQ,yBAAA;EACA,oBAAA;AAApB;AAnFA;;;EA4FQ,yBAAA;EACA,kBAAA;AAJR;AAzFA;;;EAgGY,uBAAA;AAFZ;AA9FA;;;;;;;;;;;;EAuGQ,kBAAA;EACA,gBAAA;EACA,wCAAA;AAKR;AA9GA;;;;;;;;;;;;EA4GY,yBAAA;EACA,oCAAA;AAgBZ;AAZI;EACI,aAAA;AAcR","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\n.oir-pagination {\n    margin: 0 0 20px;\n    text-align: right;\n\n    &.hidden {\n        display: none;\n    }\n\n    .page {\n        display: inline-block;\n        margin-right: 20px;\n        padding-top: 25px;\n        font-size: 15px;\n        font-family: Montserrat-Light, sans-serif;\n    }\n\n    ul {\n        display: inline-block;\n        margin: 0;\n        padding: 0;\n    }\n\n    .control {\n        display: inline-block;\n        font-family: Montserrat-Light, sans-serif;\n        border-radius: 50px;\n        border: none;\n        text-align: center;\n        margin: 0 5px;\n        outline: none;\n        box-shadow: none;\n\n        &.current {\n            background-color: @primary-base;\n            color: white;\n            text-align: center;\n            font-weight: 600;\n        }\n\n        a,\n        span {\n            text-decoration: none;\n            display: inline-block;\n            height: 25px;\n            min-width: 25px;\n            padding: 3px;\n        }\n\n        &.first,\n        &.previous {\n            margin-right: 8px;\n        }\n\n        &.next,\n        &.last {\n            margin-left: 8px;\n        }\n\n        &.first,\n        &.previous,\n        &.next,\n        &.last {\n            margin: 0;\n            padding: 0;\n            min-width: auto;\n\n            a {\n                font-weight: 100;\n                color: @primary-base;\n                transform: scale(1, 2.2);\n                -webkit-transform: scale(1, 2.2);\n                display: inline-block;\n                font-size: 13px;\n                line-height: 10px;\n                vertical-align: sub;\n                height: 23px;\n            }\n\n            &.disabled {\n                cursor: no-drop;\n\n                a {\n                    color: @disabled-fill !important;\n                    pointer-events: none;\n                }\n            }\n        }\n    }\n\n    .control:hover:not(.disabled),\n    .control:active:not(.disabled),\n    .control:focus:not(.disabled) {\n        background-color: @primary-base;\n        text-align: center;\n\n        a {\n            color: white !important;\n        }\n    }\n\n    .control.first:hover:not(.disabled), .control.previous:hover:not(.disabled), .control.next:hover:not(.disabled), .control.last:hover:not(.disabled),\n    .control.first:active:not(.disabled), .control.previous:active:not(.disabled), .control.next:active:not(.disabled), .control.last:active:not(.disabled),\n    .control.first:focus:not(.disabled), .control.previous:focus:not(.disabled), .control.next:focus:not(.disabled), .control.last:focus:not(.disabled) {\n        text-align: center;\n        font-weight: 800;\n        background-color: transparent !important;\n\n        a {\n            color: @primary-base !important;\n            background-color: @primary-40 !important\n        }\n    }\n\n    &.hidden {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
